import { useState, useEffect, useCallback } from 'react';
import { useCurrentUser } from './useCurrentUser';
import { useRoleContext } from './useRoleContext';
import { getBranchByCode } from '@/services/branchIncharge';
import type { BranchInfo } from '@/components/branch-incharge';

export function useBranchInfo() {
  const userDetails = useCurrentUser();
  const { isZoneManager, branchCode, zoneCode, stateCode, cityCode } = useRoleContext();
  const [branchInfo, setBranchInfo] = useState<BranchInfo | null>(null);
  const [loading, setLoading] = useState(true);

  const loadBranch = useCallback(async () => {
    if (isZoneManager) {
      const u = userDetails as any;
      setBranchInfo({
        Branch_Name: u?.zone       || u?.Zone       || '',
        Branch_Code: '',
        Zone_Code:   u?.zone_code  || u?.Zone_Code  || zoneCode,
        Zone:        u?.zone       || u?.Zone       || '',
        State:       u?.state      || u?.State      || '',
        State_Code:  u?.state_code || u?.State_Code || stateCode,
        City:        u?.city       || u?.City       || '',
        City_Code:   u?.city_code  || u?.City_Code  || cityCode,
      });
      setLoading(false);
      return;
    }
    if (!branchCode) { setLoading(false); return; }
    try {
      const res = await getBranchByCode(branchCode);
      if (res.status === 200 && res.data) {
        const d = res.data as any;
        const item = Array.isArray(d) ? d[0] : (d.results?.[0] ?? d);
        setBranchInfo({
          Branch_Name: item.Branch_Name ?? '',
          Branch_Code: item.Branch_Code ?? branchCode,
          State:       item.State       ?? '',
          State_Code:  stateCode || (item.State_Code ?? ''),
          City:        item.City        ?? '',
          City_Code:   cityCode  || (item.City_Code  ?? ''),
          Zone:        item.Zone        ?? '',
        });
      }
    } catch { }
    finally { setLoading(false); }
  }, [isZoneManager, branchCode, zoneCode, stateCode, cityCode, userDetails]);

  useEffect(() => { if (userDetails !== null) loadBranch(); }, [loadBranch, userDetails]);

  return { branchInfo, loading };
}
